export default __webpack_public_path__ + "static/media/logo.6aa20568.png";